<template>
	<div
		class="cart_row clearfix product_item_data"
		v-bind:data-product-id="product.id"
		v-if="product.quantity > 0 && !isNaN(product.price)"
	>
		<div class="remove_prod ease">
			<a href="javascript:void(0);" @click="removeProduct([product, $event])">
				<close_svg></close_svg>
			</a>
		</div>
		<div class="right cart_img">
			<img v-bind:src="product.image" />
		</div>
		<div class="right cart_title_wrap">
			<div class="cart_title" v-html="product.name"></div>
			<div class="pr_title_note" v-if="!product.hide_weight && product.weight">{{ weightText }}</div>
			<div class="cart_note_bt" v-if="!product.no_comments">
				<a
					href="javascript:void(0);"
					class="cartTip"
					:class="{ hasTooltip: $mq != 'mobile' }"
					title="הערה"
					@click="openNote"
				>
					&nbsp;{{ product.note }}
					<span v-if="!product.note" style="color: #2a8855">הערה</span>
					<note_svg></note_svg>
				</a>
			</div>
		</div>
		<div class="right cart_col_count">
			<div class="addto_cart" :class="{ show_it: toggleAmount }" @mouseover="toggle_am" @mouseleave="toggleOut">
				<div class="addto_cart_in clearfix">
					<div class="right minus" v-if="!isGiftProduct">
						<a href="javascript:void(0);" @click="decrementProduct([product, $event])">
							<minus_svg></minus_svg>
						</a>
					</div>
					<div class="right c_num" @click="toggle_am">
						<input
							class="addto_cart_num"
							type="number"
							@change="updateCart([product, $event])"
							v-model.lazy="product.quantity"
							:readonly="isGiftProduct"
						/>
						<div class="c_units">{{ selectedText }}</div>
					</div>
					<div class="right plus" v-if="!isGiftProduct">
						<a href="javascript:void(0);" @click="incrementProduct([product, $event])">
							<plus_svg></plus_svg>
						</a>
					</div>
				</div>
				<Producttype :product="product"></Producttype>
			</div>
		</div>
		<div class="left cart_col_total">
			<div
				class="pr_price"
				:key="totalPrice"
				ref="totalprice"
				:class="{ price_sale: bannerSale || product.oldprice }"
			>
				{{ totalPrice | currency("") }}
				<span class="currency">{{ currencySymol }}</span>
			</div>
			<div class="clearfix">
				<div class="left pr_price" :class="{ price_sale: product.oldprice }">
					{{ product.price | currency("") }}
					<span class="currency">{{ currencySymol }}</span>
					/{{ product.after_price_text ? product.after_price_text : unitPriceText }}
				</div>
				<div class="left pr_price pr_price_old" v-if="product.oldprice">
					{{ product.oldprice | currency("") }}
					<span class="currency">{{ currencySymol }}</span>
					/{{ product.after_price_text ? product.after_price_text : unitPriceText }}
				</div>
			</div>
		</div>
		<div class="both"></div>
		<div
			class="cart_sale_tx"
			v-if="
				sale &&
				sale.allowedMore &&
				product.selected !== 'kg' &&
				(!bannerSale || bannerSale === 'both') &&
				!isGiftProduct &&
				!gotBuyGetProduct
			"
		>
			ראית שיש מבצע? {{ sale.bannertext }} >>
		</div>
		<div
			class="cart_sale_tx sale_used"
			v-if="sale && (bannerSale || bannerSale == 'both') && !isGiftProduct && !isBuyGetProduct"
		>
			תענוג, חסכת {{ discount }} {{ currencySymol }}
		</div>
		<div class="cart_sale_tx sale_used" v-if="sale && (bannerSale || bannerSale == 'both') && isGiftProduct">
			איזה כיף, קיבלת מוצר מתנה
		</div>
	</div>
</template>

<script>
	import Vuex from "vuex";
	import Producttype from "../Product/ProductType";
	import plus_svg from "../../assets/img/plus.svg";
	import minus_svg from "../../assets/img/minus.svg";
	import close_svg from "../../assets/img/close.svg";
	import note_svg from "../../assets/img/note.svg";
	import { mapGetters } from "vuex";
	import store from "../../store";

	export default {
		props: ["product"], // declare the props
		store,
		data() {
			return {
				currencySymol: wpData.currencySumbol,
				toggleAmount: false,
				showEdit: false,
				saleProducts: "",
				initialRender: true,
			};
		},
		watch: {
			"product.quantity": {
				deep: false,
				immediate: false,
				handler: function (val, oldVal) {},
			},
		},

		mounted() {
			if (this.sale && this.sale.products) {
				this.$store.commit("calculateSale", this.product);
				this.$forceUpdate();
			}

			// creates massive loads, this is only for the popup, disabled for now.

			// if (this.sale && this.sale.products) {
			//   this.$store.commit('calculateSale',this.product);
			//   this.$ajax({
			//     method: "POST",
			//     url: homeUrl + "ajax.php",
			//     params: {
			//       getProducts: "",
			//       ids: JSON.stringify( this.sale.products )
			//     }
			//   }).then(res => {
			//     this.saleProducts = res.data;
			//     this.$nextTick(() => {
			//       this.$forceUpdate();
			//     })
			//   });
			// }
		},
		computed: {
			...Vuex.mapGetters({
				selectedTextG: "selectedText",
				unitPriceTextG: "unitPriceText",
				getSaleG: "getSale",
				getWeightText: "getWeightText",
				//   dateformated: "cartDateFormated"
			}),
			weightText: function () {
				let text = this.getWeightText(this.product);
				if (this.product.text_after_weight) {
					text = text + " " + this.product.text_after_weight;
				}
				return text;
			},
			sale() {
				return this.getSaleG(this.product.id);
			},

			fullPrice() {
				let full_price;
				if (
					(this.product.type === "both" || this.product.type === "unitaskg") &&
					this.product.selected === "unit"
				) {
					full_price = parseFloat(
						this.product.quantity * this.product.weight * this.product.price * this.product.divide_by
					).toFixed(2);
				} else {
					full_price = parseFloat(
						this.product.quantity * this.product.price * this.product.divide_by
					).toFixed(2);
				}
				return full_price;
			},
			bannerSale() {
				if (this.totalPrice != this.fullPrice && !this.product.oldprice) {
					if (typeof this.sale.allowedMore != "undefined" && this.sale.allowedMore) {
						return "both";
					}
					return true;
				}
				return false;
			},
			discount() {
				return parseFloat(this.fullPrice - this.totalPrice).toFixed(2);
			},
			isGiftProduct() {
				if (this.sale && typeof this.product.giftedProduct == "number" && this.product.giftedProduct > 0) {
					return true;
				}
				return false;
			},
			isBuyGetProduct() {
				if (this.sale) {
					if (this.sale.hasOwnProperty("products_get")) {
						// comax sales
						//console.log('productS_get');
						if (typeof this.sale.products_get.find((p) => p === this.product.id) != "undefined") {
							return true;
						}
					} else {
						// bogo sales
						//console.log('product_get', this.product);
						if (typeof this.sale.product_buy.find((p) => p === this.product.id) != "undefined") {
							return true;
						}
					}
				}
				return false;
			},
			gotBuyGetProduct() {
				if (this.isBuyGetProduct) {
					// console.log('this.product', this.product);
					// return this.product.gotGiftProduct;

					// let find = this.$store.state.added.find(p => (typeof p.giftedProduct == 'number' && p.giftedProduct > 0));
					let find = this.$store.state.added.find((p) => {
						// console.log(p);
						// console.log(this.product);
						return p.id === this.product.id && p.gotGiftProduct;
					});
					// console.log('find', find);
					if (typeof find != "undefined") {
						// console.log(find);
						return true;
					}
					return false;
				}
				return false;
			},
			totalPrice() {
				if (
					(typeof this.product.salePriceTotal != "undefined" && this.product.salePriceTotal > 0) ||
					this.isGiftProduct
				) {
					return parseFloat(this.product.salePriceTotal).toFixed(2);
				}
				if (
					(this.product.type === "both" || this.product.type === "unitaskg") &&
					this.product.selected === "unit"
				) {
					return parseFloat(
						this.product.quantity * this.product.weight * this.product.price * this.product.divide_by
					).toFixed(2);
				}
				return parseFloat(this.product.quantity * this.product.price * this.product.divide_by).toFixed(2);
			},
			selectedText() {
				return this.selectedTextG(this.product);
			},
			unitPriceText: function () {
				if (this.product.type === "unit") {
					if (this.product.case) {
						return "מארז";
					}
					return "יח׳";
				} else if (this.product.type === "kg") {
					return "ק״ג";
				} else if (this.product.type === "both") {
					return "ק״ג";
				} else if (this.product.type === "unitaskg") {
					return "ק״ג";
				}
				return false;
			},
		},
		methods: {
			toggleOut() {
				setTimeout(() => {
					this.toggleAmount = false;
				}, 400);
			},
			toggle_am() {
				this.toggleAmount = true;
			},
			triggerToggleAmount() {
				setTimeout(() => {
					this.toggleAmount = true;
				}, 500);
			},
			openNote() {
				this.$modal.show("product-note", { product: this.product });
			},
			...Vuex.mapActions([
				"updateCart",
				"incrementProduct",
				"decrementProduct",
				"removeProduct",
				"calculatePrice",
			]),
			...Vuex.mapMutations([
				//'deductItemCount',
				//'removeItem',
				"clearCart",
			]),
			toggleEdit() {
				this.toggleAmount = !toggleAmount;
			},
		},
		components: {
			Producttype,
			plus_svg,
			minus_svg,
			note_svg,
			close_svg,
		},
	};
</script>
